export { FaroProfiler } from './FaroProfiler';
export type { FaroProfilerProps } from './FaroProfiler';

export { withFaroProfiler } from './withFaroProfiler';
